import { createApp } from 'vue';

import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';

import Framework7 from 'framework7/lite-bundle';
import Framework7Vue, { registerComponents } from 'framework7-vue/bundle';

import 'framework7/css/bundle';
import '@/css/icons.css';

// Old design
import '@/css/old/reset.scss';
import '@/css/old/app.scss';

// New design, only used in some processes
import '@/css/new/reset.scss';
import '@/css/new/app.scss';

// Common styles from both old and new
import '@/css/colors.scss';
import '@/css/common.scss';

import { createI18nInstance } from '@/i18n';
import App from '@/components/App.vue';

Framework7.use(Framework7Vue);

const pinia = createPinia();

pinia.use(createPersistedState());

const i18n = createI18nInstance();

const app = createApp(App);

// This allows the components to render even if there was an error
app.config.errorHandler = (error, vm, info) => {
  // eslint-disable-next-line no-console
  console.error('Vue error', error, info);
};

// Register all Framework7 Vue components
registerComponents(app);

app.use(pinia);
app.use(i18n);

app.mount('#app');
